import { Lightning } from '@lightningjs/sdk'

export default class MediaButton extends Lightning.Component {
  static _template() {
    return {
      flexItem: {},
      w: 192,
      h: 84,
      Button: {
        mount: 0.5,
        x: w => w / 2,
        y: h => h / 2,
        w: 144,
        h: 72,
        color: 0xffffffff,
        texture: Lightning.Tools.getRoundRect(168, 84, 12),
        Label: {
          mount: 0.5,
          x: w => w / 2,
          y: h => h / 2,
          text: {
            fontSize: 36,
            textColor: 0xff2f85c6,
            offsetY: 80,
          },
        },
        zIndex: 2,
      },
      Shadow: {
        mount: 0.5,
        x: w => w / 2,
        y: h => h / 2,
        texture: Lightning.Tools.getShadowRect(144, 72, 0, 12),
        color: 0xff4a4a4a,
        zIndex: 1,
      },
    }
  }

  _init() {
    if (this.buttonIcon) {
      this.tag('Label').patch({ src: this.buttonIcon })
    } else if (this.buttonText) {
      this.tag('Label').patch({ text: { text: this.buttonText } })
    }
  }

  updateIcon(buttonIcon) {
    this.tag('Label').patch({ src: buttonIcon })
  }

  _focus() {
    this.patch({
      Button: {
        smooth: {
          w: 168,
          h: 84,
        },
      },
      Shadow: {
        smooth: {
          scale: 1.166,
        },
      },
    })
  }

  _unfocus() {
    this.patch({
      Button: {
        smooth: {
          w: 144,
          h: 72,
        },
      },
      Shadow: {
        smooth: {
          scale: 1,
        },
      },
    })
  }
}
